import { render, staticRenderFns } from "./sNav.vue?vue&type=template&id=dd3da3a0&"
import script from "./sNav.vue?vue&type=script&lang=js&"
export * from "./sNav.vue?vue&type=script&lang=js&"
import style0 from "./sNav.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports